// Shared, deterministic source revision used by Studio and the server release gate.
// Not a cryptographic signature: its purpose is to invalidate reviews when the
// English source changes, while the server separately enforces its own manifest.
export function sourceRevision(id, sourceText) {
  const input = String(id) + '\u0000' + String(sourceText ?? '');
  let h = 2166136261;
  for (let i = 0; i < input.length; i += 1) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0).toString(16).padStart(8, '0');
}

export function reviewIsCurrent(row, entry) {
  return Boolean(row && entry && entry.id === row.id
    && entry.sourceRevision === sourceRevision(row.id, row.sourceText)
    && entry.sourceText === row.sourceText
    && String(entry.translatedText || '').trim()
    && (entry.decision === 'accepted' || entry.decision === 'changed'));
}

export function translationReviewSummary(rows, entries = {}) {
  const publishable = rows.filter((row) => row.publicationTarget !== 'excluded');
  const excluded = rows.filter((row) => row.publicationTarget === 'excluded');
  const reviewed = publishable.filter((row) => reviewIsCurrent(row, entries[row.id]));
  const needsContext = publishable.filter((row) => entries[row.id]?.decision === 'needs_context');
  const stale = publishable.filter((row) => entries[row.id] && !reviewIsCurrent(row, entries[row.id]));
  return { total: publishable.length, reviewed: reviewed.length, outstanding: publishable.length - reviewed.length,
    stale: stale.length, needsContext: needsContext.length, excluded: excluded.length,
    complete: publishable.length > 0 && reviewed.length === publishable.length,
    safeToPublish: publishable.length > 0 && reviewed.length === publishable.length && excluded.every((row) => row.exclusionCode === 'intentionally_english_only') };
}
